import * as Combobox from '@givebutter/primitives/combobox';

const PaymentMethodOptions = () => {
    return (
        <>
            <Combobox.Item value="card">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Credit Card</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="cash">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Cash</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="check">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Check</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="ach">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>ACH</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="venmo">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Venmo</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="paypal">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Paypal</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="digital_wallet">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Digital Wallet</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="donor_advised_fund">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Donor Advised Fund</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="in-kind">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>In-kind</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="stock">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Stock</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="property">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Property</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="other">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>Other</Combobox.ItemText>
            </Combobox.Item>
            <Combobox.Item value="none">
                <Combobox.CheckboxIndicator />
                <Combobox.ItemText>No Payment</Combobox.ItemText>
            </Combobox.Item>
        </>
    );
};

export { PaymentMethodOptions };
